import React from "react";
import clsx from "clsx";

import styles from "./../splitProfile.module.scss";

type WaterfallExampleMessageProps = {
	value: string;
};

export const WaterfallExampleMessage = ({
	value,
}: WaterfallExampleMessageProps) => (
	<div className={clsx(styles.externalContent)}>
		<span className="text-muted fs-4">
			Taken as an Example: {`$${value}`}
		</span>
	</div>
);
